import { render, staticRenderFns } from "./IPhoneMessage.vue?vue&type=template&id=5c7aff38&scoped=true&"
import script from "./IPhoneMessage.vue?vue&type=script&lang=js&"
export * from "./IPhoneMessage.vue?vue&type=script&lang=js&"
import style0 from "./IPhoneMessage.vue?vue&type=style&index=0&id=5c7aff38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7aff38",
  null
  
)

export default component.exports